import CampManager from "../../pages/CampManagement"
import CampDashboard from "../../pages/CampManagement/dashboard"

export const campManagementRoutes = [
  { path: "/camp", component: <CampManager /> },
  { path: "/camp-manager", component: <CampManager /> },
  { path: "/camp-dashboard", component: <CampDashboard /> },
]
